// extracted by mini-css-extract-plugin
export default {"faq_container":"Faq_faq_container__1xQl6","faq_inner":"Faq_faq_inner__+RBPh","logo":"Faq_logo__0nN-i","header":"Faq_header__ZrFHH"};